// --- components/about/AboutStatistics.tsx ---
'use client';
import React from 'react';


export const AboutStatistics: React.FC = () => ( // Props removed
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 w-full mb-12 md:mb-16">
    <div className="bg-white p-6 rounded-lg text-center shadow-md">
      <h3 className="text-4xl font-medium text-gray-900 mb-2">25</h3>
      <p className="text-gray-600">Years of Industry Experience</p>
    </div>
    <div className="bg-white p-6 rounded-lg text-center shadow-md">
      <h3 className="text-4xl font-medium text-gray-900 mb-2">99%</h3>
      <p className="text-gray-600">On-Time Delivery Rate</p>
    </div>
    <div className="bg-white p-6 rounded-lg text-center shadow-md">
      <h3 className="text-4xl font-medium text-gray-900 mb-2">200+</h3>
      <p className="text-gray-600">Satisfied Clients Worldwide</p>
    </div>
    <div className="bg-white p-6 rounded-lg text-center shadow-md">
      <h3 className="text-4xl font-medium text-gray-900 mb-2">20+</h3>
      <p className="text-gray-600">Employees for Your Success</p>
    </div>
  </div>
);